import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMuteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M505 116Q505 100 496 91.5 487 83 473 83 454 83 441 96L189 336 53 336Q36 336 28.5 343.5 21 351 21 368L21 624Q21 642 29 650 37 658 55 658L193 658 439 900Q454 918 473 918 486 918 495.5 907.5 505 897 505 878ZM1001 356L945 301 806 441 667 302 612 356 751 495 611 635 667 690 806 550 945 689 1000 635 861 496Z" })
});
export default SvgMuteIcon;
